import type { Call } from '@entities/call';

import type { ConnectedCallCrmOps } from '@usecases/connected-call.usecase';

import type { IntegrationRepository } from '@infra/repositories/integration.repository';
import type { UserRepository } from '@infra/repositories/user.repository';

import type {
  SearchRecordResult,
  SearchVoiceObjectResult,
} from '@main/sf-connector/scv-object-manager';
import { ScvObjectManager } from '@main/sf-connector/scv-object-manager';
import sleep from '@main/utils/sleep';

export class SalesforceConnectedCallCrmOps implements ConnectedCallCrmOps {
  constructor(
    private userRepository: UserRepository,
    private integrationRepository: IntegrationRepository,
  ) {}

  preCall(callUuid: string, call: Call): Promise<void> {
    const { id: vendorCallKey } = call;
    return this.linkRecordWithVoiceObject(vendorCallKey, callUuid, call.to);
  }

  private async linkRecordWithVoiceObject(
    vendorCallKey: string,
    callUuid: string,
    to: string,
  ): Promise<void> {
    await sleep(1000);

    const [voiceObject] = await Promise.all([
      ScvObjectManager.searchVoiceObject(vendorCallKey, ''),
    ]);

    let searchRecordResult: SearchRecordResult = undefined;

    if (!this.voiceObjectHasRelatedRecord(voiceObject)) {
      searchRecordResult = await ScvObjectManager.searchRecord(to, true, false);
    }

    await ScvObjectManager.updateVoiceObject(
      vendorCallKey,
      callUuid,
      searchRecordResult ? searchRecordResult.Id : undefined,
    );
  }

  private voiceObjectHasRelatedRecord(
    voiceObject: SearchVoiceObjectResult,
  ): boolean {
    return !!voiceObject && !!voiceObject.RelatedRecordId;
  }
}
